import { SeedSource } from "./seed-source.mjs"

export const NewScheduleCreationType = Object.freeze({
    NEW_PUBLISHED: "new-published",
})

export function isAlreadyPublishedNewSchedule(draft) {
    return draft?.seedSource === SeedSource.NEW && draft?.creationType === NewScheduleCreationType.NEW_PUBLISHED
}
